var AG_GRID_KEY = '$AG_GRID_KEY'; // NOSONAR
var CS_API_BASE_URL = '$CS_API_BASE_URL'; // NOSONAR
var CS_NOTIFICATIONS_BASE_URL = '$CS_NOTIFICATIONS_BASE_URL'; // NOSONAR
var HARNESS_KEY = '$HARNESS_KEY'; // NOSONAR
